<script>
import { mapGetters } from 'vuex';
import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  props: {
    accountId: { type: Number, default: 0 },
  },
  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    dashboardPath() {
      return frontendURL(`accounts/${this.accountId}/dashboard`);
    },
  },
};
</script>

<template>
  <div class="logo-size m-4 mb-10">
    <router-link :to="dashboardPath" replace>
      <img :src="globalConfig.logoThumbnail" alt="Iuconnect" />
    </router-link>
  </div>
</template>

<style scoped>
.logo-size {
  width: 55.475px;
  height: 42.162px;
  flex-shrink: 0;
}
</style>
